import VerticalBarChartWidget from './VerticalBarChartWidget';

export default VerticalBarChartWidget;
